// extracted by mini-css-extract-plugin
export default {"wrap":"card_wrap__GjxQl","borderless":"card_borderless__EBruS"};